var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400,0H112C50.144,0,0,50.144,0,112v288c0,61.856,50.144,112,112,112h288c61.856,0,112-50.144,112-112V112 C512,50.144,461.856,0,400,0z M480,400c0,44.183-35.817,80-80,80H112c-44.183,0-80-35.817-80-80V112c0-44.183,35.817-80,80-80 h288c44.183,0,80,35.817,80,80V400z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,112h-32c-8.837,0-16,7.163-16,16v32c0,8.837,7.163,16,16,16h32c8.837,0,16-7.163,16-16v-32 C176,119.163,168.837,112,160,112z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,224h-32c-8.837,0-16,7.163-16,16v32c0,8.837,7.163,16,16,16h32c8.837,0,16-7.163,16-16v-32 C176,231.163,168.837,224,160,224z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,336h-32c-8.837,0-16,7.163-16,16v32c0,8.837,7.163,16,16,16h32c8.837,0,16-7.163,16-16v-32 C176,343.163,168.837,336,160,336z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 128,
    width: 192,
    height: 32,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 240,
    width: 192,
    height: 32,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 352,
    width: 192,
    height: 32,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNeed);
export default __webpack_public_path__ + "static/media/addNeed.ce20dcec.svg";
export { ForwardRef as ReactComponent };